import type { ConfigType } from '@plone/registry';

const applyConfig = (config: ConfigType) => {
  config.settings.isMultilingual = false;
  config.settings.supportedLanguages = ['en', 'de'];
  config.settings.defaultLanguage = 'en';

  return config;
};

export default applyConfig;
